<template>
  <div class="flex flex-col mt-10">
    <h2 class="text-sm md:text-xs uppercase font-semibold tracking-widest py-2 border-b border-black">
      {{ $t('order.summary') }}
    </h2>
    <section class="md:flex flex-col mt-10 border-b border-black hidden">
      <div class="flex mb-10 text-sm font-semibold tracking-widest">
        <h3 class="w-1/5">
          {{ $t('order.product') }}
        </h3>
        <h3 class="w-2/5">
          {{ $t('order.description') }}
        </h3>
        <div class="w-2/5 flex text-center">
          <h3 class="w-1/3">
            {{ $t('order.code') }}
          </h3>
          <h3 class="w-1/3">
            {{ $t('order.qty') }}
          </h3>
          <h3 class="w-1/3">
            {{ $t('order.amount') }}
          </h3>
        </div>
      </div>
      <div v-for="line in lines" :key="line.id"
        class="flex items-center mb-6 text-xs" :class="fontHairline()"
      >
        <div class="w-1/5">
          <img :src="line.product.cover" alt="" class="w-2/3">
        </div>
        <h4 class="w-2/5">
          {{ line.product.description }}
        </h4>
        <div class="w-2/5 flex text-center font-bold" >
          <h4 class="w-1/3">
            {{ line.product.sku }}
          </h4>
          <h4 class="w-1/3">
            {{ line.quantity }}
          </h4>
          <h4 class="w-1/3">
            {{ formatter.format(line.total_with_taxes / 100) }}
          </h4>
        </div>
      </div>
    </section>
    <section class="md:hidden border-b border-black py-4">
      <div v-for="line in lines" :key="line.id"
        class="flex items-center justify-center text-sm md:text-xs w-full"
       :class="fontHairline()">
        <div class="w-1/2 m-2">
          <img :src="line.product.cover" alt="">
        </div>
        <h3 class="w-1/2 flex-col m-2">
          <h4 class="font-bold">
            {{ line.product.description }}
          </h4>
          <div class="flex mt-2">
            <h4 class="w-2/5 font-medium">
              {{ $t('order.code') }}:
            </h4>
            <h4>
              {{ line.product.sku }}
            </h4>
          </div>
          <div class="flex">
            <h4 class="w-2/5 font-medium">
              {{ $t('order.qty') }}:
            </h4>
            <h4>
              {{ line.quantity }}
            </h4>
          </div>
          <div class="flex">
            <h4 class="w-2/5 font-medium">
              {{ $t('order.amount') }}:
            </h4>
            <h4>
              {{ formatter.format(line.total_with_taxes / 100) }}
            </h4>
          </div>
        </h3>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['lines'],
};
</script>
